/* Painting Color Palette — Art & See free tool (Capitão C, lote 5, 2026-09-12)
   Extracts the palette from the real painting image IN THE BROWSER (median cut over the
   CDN image at &width=400, crossOrigin=anonymous — the Shopify CDN answers
   access-control-allow-origin:* , MAPA-B §1). Falls back to the pre-computed palette in
   catalogue row.c when the canvas is tainted or the image 404s.
   Data layer: window.ArtSeeCatalog (CONTRATO-DADOS.md §2). No other network call.

   ROOM-HARMONY RULE (documented, deterministic, no AI):
     1. Extract 6 colours from the room photo, same median cut.
     2. Split into chromatic (S >= .12 and .08 < L < .92) and neutral.
     3. anchor  = largest-area chromatic colour (if the room is all neutral, the largest
                  neutral is used and step 4 only contributes the neutral).
     4. Query = [anchor, 2nd chromatic if any, complement(anchor), dominant neutral]
                complement = HSL hue +180°, S capped at .55, L mirrored into .30–.65.
        The complement is what stops the art from camouflaging into the wall: the room
        supplies the harmony, one opposite hue supplies the accent.
     5. ArtSeeCatalog.similarColor(query, {limit:24}) then re-rank by |mean L of the
        painting − mean L of the room| so the result also matches the room's brightness.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-pcp]');
  if (!root) return;

  var H = 0, T = 1, A = 2, P = 4, C = 11;
  var SWATCHES = 6;

  /* ---------------------------------------------------------- colour names
     ~150 names: CSS named colours plus the pigment vocabulary a painter uses.
     Nearest match by CIE76 ΔE in Lab (ArtSeeCatalog.rgbToLab). */
  var NAMES = ('black:000000,white:ffffff,ivory black:231f20,lamp black:2b2b2b,mars black:1c1c1c,' +
    'charcoal:36454f,payne\'s grey:536878,davy\'s grey:555555,slate grey:708090,dim grey:696969,' +
    'grey:808080,silver:c0c0c0,light grey:d3d3d3,gainsboro:dcdcdc,whitesmoke:f5f5f5,' +
    'titanium white:fbfcfa,zinc white:f4f5f0,lead white:f6f3e8,flake white:f3efe0,ivory:fffff0,' +
    'linen:faf0e6,old lace:fdf5e6,seashell:fff5ee,cream:fffdd0,beige:f5f5dc,' +
    'antique white:faebd7,bisque:ffe4c4,wheat:f5deb3,tan:d2b48c,buff:f0dc82,' +
    'khaki:c3b091,dark khaki:bdb76b,sand:c2b280,taupe:483c32,drab:967117,' +
    'naples yellow:fada5e,chrome yellow:ffa700,cadmium yellow:fff600,lemon yellow:fff44f,' +
    'yellow:ffff00,gold:ffd700,amber:ffbf00,mustard:ffdb58,yellow ochre:cb9d06,' +
    'gold ochre:c9942a,raw sienna:d68a59,burnt sienna:e97451,sienna:a0522d,' +
    'raw umber:826644,burnt umber:8a3324,umber:635147,van dyck brown:664228,' +
    'sepia:704214,brown:a52a2a,saddle brown:8b4513,chocolate:d2691e,chestnut:954535,' +
    'russet:80461b,mahogany:c04000,rust:b7410e,copper:b87333,bronze:cd7f32,' +
    'cadmium orange:ed872d,orange:ffa500,tangerine:f28500,coral:ff7f50,salmon:fa8072,' +
    'peach:ffe5b4,apricot:fbceb1,terracotta:e2725b,vermilion:e34234,scarlet:ff2400,' +
    'cadmium red:e30022,red:ff0000,firebrick:b22222,crimson:dc143c,alizarin crimson:e32636,' +
    'carmine:960018,madder lake:a71930,rose madder:e32636,venetian red:c80815,indian red:cd5c5c,' +
    'maroon:800000,burgundy:800020,oxblood:4a0000,wine:722f37,rose:ff007f,' +
    'pink:ffc0cb,blush:de5d83,dusty rose:c08081,mauve:e0b0ff,lilac:c8a2c8,' +
    'orchid:da70d6,magenta:ff00ff,fuchsia:ff77ff,cobalt violet:7d4d8b,dioxazine purple:4b2d5e,' +
    'purple:800080,violet:8f00ff,plum:8e4585,aubergine:3d0c02,indigo:4b0082,' +
    'navy:000080,midnight blue:191970,prussian blue:003153,ultramarine:120a8f,' +
    'french ultramarine:1b1f8a,cobalt blue:0047ab,royal blue:4169e1,blue:0000ff,' +
    'cerulean blue:2a52be,azure:007fff,sky blue:87ceeb,powder blue:b0e0e6,' +
    'manganese blue:0072b5,steel blue:4682b4,denim:1560bd,slate blue:6a5acd,' +
    'periwinkle:ccccff,phthalo blue:000f89,teal:008080,petrol:005f6a,' +
    'turquoise:40e0d0,aquamarine:7fffd4,cyan:00ffff,phthalo green:123524,' +
    'viridian:40826d,emerald green:50c878,green:008000,forest green:228b22,' +
    'hunter green:355e3b,bottle green:006a4e,sap green:507d2a,olive green:6b8e23,' +
    'olive:808000,moss green:8a9a5b,sage:9caf88,terre verte:6e7f57,' +
    'chrome green:1c352d,pistachio:93c572,mint:98ff98,celadon:ace1af,' +
    'lime:bfff00,chartreuse:7fff00,pea green:8eb021,fern:4f7942').split(',');
  var NAME_LAB = null;
  function nameOf(hex) {
    if (!NAME_LAB) {
      NAME_LAB = NAMES.map(function (p) {
        var i = p.lastIndexOf(':'), h = p.slice(i + 1), rgb = hexToRgb(h);
        return { n: p.slice(0, i), lab: toLab(rgb[0], rgb[1], rgb[2]) };
      });
    }
    var rgb = hexToRgb(hex), lab = toLab(rgb[0], rgb[1], rgb[2]), best = NAME_LAB[0], bd = Infinity;
    for (var i = 0; i < NAME_LAB.length; i++) {
      var l = NAME_LAB[i].lab, d = (lab[0] - l[0]) * (lab[0] - l[0]) + (lab[1] - l[1]) * (lab[1] - l[1]) + (lab[2] - l[2]) * (lab[2] - l[2]);
      if (d < bd) { bd = d; best = NAME_LAB[i]; }
    }
    return best.n;
  }

  /* -------------------------------------------------------------- utilities */
  function el(t, c, x) { var n = document.createElement(t); if (c) n.className = c; if (x != null) n.textContent = x; return n; }
  function hexToRgb(h) { var s = String(h).replace('#', ''), n = parseInt(s, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function toHex(r, g, b) { return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1); }
  function toLab(r, g, b) {
    if (window.ArtSeeCatalog && ArtSeeCatalog.rgbToLab) return ArtSeeCatalog.rgbToLab(r, g, b);
    function f(u) { u /= 255; return u <= 0.04045 ? u / 12.92 : Math.pow((u + 0.055) / 1.055, 2.4); }
    var R = f(r), G = f(g), B = f(b);
    var x = (R * .4124564 + G * .3575761 + B * .1804375) / .95047;
    var y = (R * .2126729 + G * .7151522 + B * .072175);
    var z = (R * .0193339 + G * .119192 + B * .9503041) / 1.08883;
    function t(u) { return u > .008856 ? Math.pow(u, 1 / 3) : 7.787 * u + 16 / 116; }
    x = t(x); y = t(y); z = t(z);
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  }
  function rgb2hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, s = 0;
    if (mx !== mn) {
      var d = mx - mn;
      s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = (g - b) / d + (g < b ? 6 : 0); else if (mx === g) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s, l];
  }
  function hsl2rgb(h, s, l) {
    h = ((h % 360) + 360) % 360 / 360;
    if (s === 0) { var v = Math.round(l * 255); return [v, v, v]; }
    var q = l < .5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
    function hue(t) { if (t < 0) t += 1; if (t > 1) t -= 1; if (t < 1 / 6) return p + (q - p) * 6 * t; if (t < .5) return q; if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6; return p; }
    return [Math.round(hue(h + 1 / 3) * 255), Math.round(hue(h) * 255), Math.round(hue(h - 1 / 3) * 255)];
  }
  function money(v) { return '$' + (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function track(ev, p) {
    try {
      if (window.ArtSeeCatalog && ArtSeeCatalog.track) return ArtSeeCatalog.track(ev, p);
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev, tool: 'painting-color-palette' };
      for (var k in p) o[k] = p[k];
      window.dataLayer.push(o);
    } catch (e) { }
  }

  /* ------------------------------------------------------------- median cut */
  function medianCut(px, k) {
    if (!px.length) return [];
    var boxes = [mkBox(px)];
    while (boxes.length < k) {
      boxes.sort(function (a, b) { return b.range * b.px.length - a.range * a.px.length; });
      var b = boxes.shift();
      if (!b || b.px.length < 2 || b.range === 0) { if (b) boxes.push(b); break; }
      var ch = b.ch;
      b.px.sort(function (x, y) { return x[ch] - y[ch]; });
      var mid = b.px.length >> 1;
      boxes.push(mkBox(b.px.slice(0, mid)), mkBox(b.px.slice(mid)));
    }
    var total = px.length;
    return boxes.map(function (b) {
      var r = 0, g = 0, bl = 0;
      for (var i = 0; i < b.px.length; i++) { r += b.px[i][0]; g += b.px[i][1]; bl += b.px[i][2]; }
      var n = b.px.length;
      return { hex: toHex(Math.round(r / n), Math.round(g / n), Math.round(bl / n)), pct: n / total * 100 };
    }).sort(function (a, b) { return b.pct - a.pct; });
  }
  function mkBox(px) {
    var mn = [255, 255, 255], mx = [0, 0, 0];
    for (var i = 0; i < px.length; i++) for (var c = 0; c < 3; c++) {
      if (px[i][c] < mn[c]) mn[c] = px[i][c];
      if (px[i][c] > mx[c]) mx[c] = px[i][c];
    }
    var ch = 0, range = mx[0] - mn[0];
    if (mx[1] - mn[1] > range) { ch = 1; range = mx[1] - mn[1]; }
    if (mx[2] - mn[2] > range) { ch = 2; range = mx[2] - mn[2]; }
    return { px: px, ch: ch, range: range };
  }
  function extractFromImage(img, k) {
    var side = 150, sc = Math.min(1, side / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height, 1));
    var w = Math.max(1, Math.round((img.naturalWidth || img.width) * sc));
    var h = Math.max(1, Math.round((img.naturalHeight || img.height) * sc));
    var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0, w, h);
    var d = cx.getImageData(0, 0, w, h).data, px = [];
    for (var i = 0; i < d.length; i += 4) { if (d[i + 3] > 127) px.push([d[i], d[i + 1], d[i + 2]]); }
    return medianCut(px, k || SWATCHES);
  }
  function paletteFromRow(row) {
    var out = [], parts = String(row[C] || '').split(',');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split(':'), hex = kv[0].replace('#', '');
      if (hex.length !== 6) continue;
      out.push({ hex: hex, pct: Number(kv[1]) || 0 });
    }
    return out;
  }

  /* -------------------------------------------------------------- DOM refs */
  var qIn = root.querySelector('[data-pcp-q]');
  var sugg = root.querySelector('[data-pcp-sugg]');
  var starter = root.querySelector('[data-pcp-starter]');
  var panel = root.querySelector('[data-pcp-panel]');
  var similar = root.querySelector('[data-pcp-similar]');
  var roomOut = root.querySelector('[data-pcp-room-out]');
  var fileArt = root.querySelector('[data-pcp-upload]');
  var fileRoom = root.querySelector('[data-pcp-room-file]');

  var state = { row: null, pal: [], src: '', vsRow: null, vsPal: [], compareMode: false };

  /* ------------------------------------------------------------------ hash */
  function hashRead() {
    var o = {};
    location.hash.replace(/^#/, '').split('&').forEach(function (p) {
      var i = p.indexOf('='); if (i > 0) o[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1));
    });
    return o;
  }
  function hashWrite() {
    var s = state.row ? 'p=' + encodeURIComponent(state.row[H]) + (state.vsRow ? '&vs=' + encodeURIComponent(state.vsRow[H]) : '') : '';
    try { history.replaceState(null, '', location.pathname + location.search + (s ? '#' + s : '')); } catch (e) { }
  }

  /* ---------------------------------------------------------------- render */
  function swatchList(pal, host, compact) {
    host.innerHTML = '';
    pal.forEach(function (c) {
      var rgb = hexToRgb(c.hex), hsl = rgb2hsl(rgb[0], rgb[1], rgb[2]);
      var b = el('button', 'pcp-sw' + (compact ? ' pcp-sw--compact' : ''));
      b.type = 'button';
      b.title = 'Copy #' + c.hex;
      var chip = el('span', 'pcp-sw__chip');
      chip.style.background = '#' + c.hex;
      b.appendChild(chip);
      var meta = el('span', 'pcp-sw__meta');
      meta.appendChild(el('strong', 'pcp-sw__hex', '#' + c.hex.toUpperCase()));
      meta.appendChild(el('span', 'pcp-sw__name', nameOf(c.hex)));
      if (!compact) {
        meta.appendChild(el('span', 'pcp-sw__num', 'rgb(' + rgb.join(', ') + ')'));
        meta.appendChild(el('span', 'pcp-sw__num', 'hsl(' + Math.round(hsl[0]) + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%)'));
      }
      meta.appendChild(el('span', 'pcp-sw__pct', Math.round(c.pct) + '% of the canvas'));
      b.appendChild(meta);
      b.addEventListener('click', function () { copy('#' + c.hex.toUpperCase(), b); });
      host.appendChild(b);
    });
  }
  function proportionBar(pal) {
    var bar = el('div', 'pcp-bar');
    var tot = pal.reduce(function (s, c) { return s + c.pct; }, 0) || 1;
    pal.forEach(function (c) {
      var i = el('i');
      i.style.background = '#' + c.hex;
      i.style.width = (c.pct / tot * 100) + '%';
      i.title = '#' + c.hex.toUpperCase() + ', ' + Math.round(c.pct) + '%';
      bar.appendChild(i);
    });
    return bar;
  }
  function copy(text, btn) {
    var done = function () {
      if (!btn) return;
      var old = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', old);
      btn.classList.add('is-copied');
      var lbl = btn.querySelector('.pcp-sw__hex');
      if (lbl) { var prev = lbl.textContent; lbl.textContent = 'Copied'; setTimeout(function () { lbl.textContent = prev; btn.classList.remove('is-copied'); }, 1100); }
      else { btn.textContent = 'Copied ✓'; setTimeout(function () { btn.textContent = old; btn.classList.remove('is-copied'); }, 1100); }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, fallback);
    else fallback();
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) { }
      document.body.removeChild(ta); done();
    }
  }

  function fmtHexList(pal) { return pal.map(function (c) { return '#' + c.hex.toUpperCase(); }).join('\n'); }
  function fmtCss(pal, label) {
    return ':root {\n' + pal.map(function (c, i) {
      return '  --' + slug(label) + '-' + (i + 1) + ': #' + c.hex.toUpperCase() + '; /* ' + nameOf(c.hex) + ', ' + Math.round(c.pct) + '% */';
    }).join('\n') + '\n}';
  }
  function fmtJson(pal, label) {
    return JSON.stringify({
      name: label, source: 'art-and-see.com/pages/painting-color-palette',
      colors: pal.map(function (c) {
        var rgb = hexToRgb(c.hex);
        return { hex: '#' + c.hex.toUpperCase(), rgb: rgb, name: nameOf(c.hex), pct: Math.round(c.pct * 10) / 10 };
      })
    }, null, 2);
  }
  function fmtGpl(pal, label) {
    var s = 'GIMP Palette\nName: ' + label + '\nColumns: ' + pal.length + '\n#\n';
    pal.forEach(function (c) {
      var rgb = hexToRgb(c.hex);
      s += pad(rgb[0]) + ' ' + pad(rgb[1]) + ' ' + pad(rgb[2]) + '\t' + nameOf(c.hex) + '\n';
    });
    return s;
    function pad(n) { return String(n).padStart(3, ' '); }
  }
  function fmtAse(pal, label) {
    // ASE-shaped JSON (readable by scripts and by Adobe's own JSON importers). Binary .ase
    // is not generated in the browser — the file says so in its own header field.
    return JSON.stringify({
      version: '1.0', format: 'ASE-compatible JSON (not binary .ase)', name: label,
      swatches: pal.map(function (c) {
        var rgb = hexToRgb(c.hex);
        return { name: nameOf(c.hex) + ' #' + c.hex.toUpperCase(), model: 'RGB', color: [+(rgb[0] / 255).toFixed(4), +(rgb[1] / 255).toFixed(4), +(rgb[2] / 255).toFixed(4)], type: 'global' };
      })
    }, null, 2);
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'palette'; }
  function download(name, text, mime) {
    var bl = new Blob([text], { type: mime || 'text/plain;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(bl); a.download = name;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
  }
  function downloadCard(pal, label, sub) {
    var cv = document.createElement('canvas'); cv.width = 1200; cv.height = 700;
    var cx = cv.getContext('2d');
    cx.fillStyle = '#FEFBF6'; cx.fillRect(0, 0, 1200, 700);
    cx.fillStyle = '#5C4033'; cx.font = '700 20px Inter, Helvetica, Arial, sans-serif';
    cx.fillText('COLOR PALETTE', 60, 78);
    cx.fillStyle = '#000'; cx.font = '800 42px Inter, Helvetica, Arial, sans-serif';
    cx.fillText(label.slice(0, 42), 60, 132);
    if (sub) { cx.fillStyle = '#707070'; cx.font = '400 22px Inter, Helvetica, Arial, sans-serif'; cx.fillText(sub, 60, 168); }
    var x = 60, w = (1080) / pal.length;
    pal.forEach(function (c) {
      cx.fillStyle = '#' + c.hex; cx.fillRect(x, 210, w - 12, 300);
      cx.fillStyle = '#000'; cx.font = '700 20px Inter, Helvetica, Arial, sans-serif';
      cx.fillText('#' + c.hex.toUpperCase(), x, 552);
      cx.fillStyle = '#707070'; cx.font = '400 17px Inter, Helvetica, Arial, sans-serif';
      cx.fillText(nameOf(c.hex).slice(0, 18), x, 578);
      cx.fillText(Math.round(c.pct) + '%', x, 602);
      x += w;
    });
    cx.fillStyle = '#4B5563'; cx.font = '400 20px Inter, Helvetica, Arial, sans-serif';
    cx.fillText('art-and-see.com  ·  palette measured from the painting', 60, 660);
    cv.toBlob(function (bl) {
      if (!bl) return;
      var a = document.createElement('a');
      a.href = URL.createObjectURL(bl); a.download = slug(label) + '-palette.png';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
    }, 'image/png');
  }

  /* ------------------------------------------------------------ main panel */
  function renderPanel() {
    panel.innerHTML = '';
    panel.hidden = false;
    var label = state.row ? state.row[T] : 'Your image';
    var sub = state.row ? state.row[A] : '';

    var head = el('div', 'pcp-panel__head');
    var fig = el('div', 'pcp-panel__fig');
    var img = new Image();
    img.alt = label + (sub ? ' by ' + sub : '');
    img.src = state.src;
    fig.appendChild(img);
    head.appendChild(fig);

    var info = el('div', 'pcp-panel__info');
    info.appendChild(el('h2', 'pcp-panel__title', label));
    if (sub) info.appendChild(el('p', 'pcp-panel__artist', sub));
    info.appendChild(el('p', 'pcp-panel__prov', state.exact
      ? 'Measured from the painting image, ' + state.pal.length + ' colours, by share of canvas.'
      : 'Pre-computed palette from our catalogue index (the live image could not be read in this browser).'));
    info.appendChild(proportionBar(state.pal));
    if (state.row) {
      var links = el('p', 'pcp-panel__links');
      var a1 = el('a', 'pcp-link', 'Buy this painting from ' + money(state.row[P]));
      a1.href = ArtSeeCatalog.pdpUrl(state.row);
      a1.addEventListener('click', function () { track('tool_cta_click', { handle: state.row[H], target: 'pdp' }); });
      links.appendChild(a1);
      var a2 = el('a', 'pcp-link', 'See it on your wall');
      a2.href = '/pages/see-art-on-your-wall#art=' + encodeURIComponent(state.row[H]);
      links.appendChild(a2);
      info.appendChild(links);
    }
    head.appendChild(info);
    panel.appendChild(head);

    var sw = el('div', 'pcp-swatches');
    swatchList(state.pal, sw);
    panel.appendChild(sw);

    var bar = el('div', 'pcp-tools');
    addMenu(bar, 'Copy all', [
      ['Hex list', function () { return fmtHexList(state.pal); }],
      ['CSS custom properties', function () { return fmtCss(state.pal, label); }],
      ['JSON', function () { return fmtJson(state.pal, label); }]
    ], function (txt, b) { copy(txt, b); track('tool_cta_click', { target: 'copy_all' }); });
    addMenu(bar, 'Download', [
      ['PNG palette card', null], ['ASE-compatible JSON', null], ['.gpl (GIMP / Krita)', null]
    ], null, function (which) {
      if (which === 0) downloadCard(state.pal, label, sub);
      if (which === 1) download(slug(label) + '.ase.json', fmtAse(state.pal, label), 'application/json');
      if (which === 2) download(slug(label) + '.gpl', fmtGpl(state.pal, label), 'text/plain;charset=utf-8');
      track('tool_cta_click', { target: 'download' });
    });
    var cmp = el('button', 'pcp-btn pcp-btn--outline', state.vsRow ? 'Change comparison' : 'Compare with another painting');
    cmp.type = 'button';
    cmp.addEventListener('click', function () {
      state.compareMode = true;
      qIn.value = '';
      qIn.placeholder = 'Search the painting to compare with…';
      qIn.focus();
      qIn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    bar.appendChild(cmp);
    panel.appendChild(bar);

    if (state.vsRow) {
      var vs = el('div', 'pcp-vs');
      var cols = el('div', 'pcp-vs__cols');
      [[state.row, state.pal, state.src], [state.vsRow, state.vsPal, ArtSeeCatalog.imageUrl(state.vsRow, 400)]].forEach(function (pair) {
        var col = el('div', 'pcp-vs__col');
        col.appendChild(el('h3', null, pair[0] ? pair[0][T] : 'Your image'));
        col.appendChild(proportionBar(pair[1]));
        var l = el('div', 'pcp-swatches pcp-swatches--compact');
        swatchList(pair[1], l, true);
        col.appendChild(l);
        cols.appendChild(col);
      });
      vs.appendChild(el('h3', 'pcp-vs__h', 'Side by side'));
      vs.appendChild(cols);
      var clear = el('button', 'pcp-btn pcp-btn--ghost', 'Clear comparison');
      clear.type = 'button';
      clear.addEventListener('click', function () { state.vsRow = null; state.vsPal = []; hashWrite(); renderPanel(); });
      vs.appendChild(clear);
      panel.appendChild(vs);
    }

    renderSimilar();
  }

  function addMenu(host, label, items, onCopy, onPick) {
    var wrap = el('div', 'pcp-menu');
    var b = el('button', 'pcp-btn', label);
    b.type = 'button';
    b.setAttribute('aria-expanded', 'false');
    var list = el('div', 'pcp-menu__list');
    list.hidden = true;
    items.forEach(function (it, i) {
      var o = el('button', 'pcp-menu__item', it[0]);
      o.type = 'button';
      o.addEventListener('click', function () {
        list.hidden = true; b.setAttribute('aria-expanded', 'false');
        if (onPick) onPick(i); else if (onCopy) onCopy(it[1](), b);
      });
      list.appendChild(o);
    });
    b.addEventListener('click', function () {
      var open = list.hidden;
      document.querySelectorAll('.pcp-menu__list').forEach(function (n) { n.hidden = true; });
      list.hidden = !open;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    wrap.appendChild(b); wrap.appendChild(list);
    host.appendChild(wrap);
  }

  /* --------------------------------------------------- similar palette grid */
  function cardFor(row) {
    var a = el('a', 'pcp-card');
    a.href = ArtSeeCatalog.pdpUrl(row);
    a.addEventListener('click', function () { track('tool_cta_click', { handle: row[H], target: 'similar' }); });
    var im = el('span', 'pcp-card__img');
    var img = new Image();
    img.loading = 'lazy'; img.decoding = 'async';
    img.alt = row[T] + ' by ' + row[A] + ', hand-painted oil reproduction';
    img.src = ArtSeeCatalog.imageUrl(row, 400);
    im.appendChild(img); a.appendChild(im);
    var strip = el('span', 'pcp-card__strip');
    paletteFromRow(row).slice(0, 6).forEach(function (c) { var i = el('i'); i.style.background = '#' + c.hex; strip.appendChild(i); });
    a.appendChild(strip);
    a.appendChild(el('strong', 'pcp-card__t', row[T]));
    a.appendChild(el('span', 'pcp-card__a', row[A]));
    a.appendChild(el('span', 'pcp-card__p', 'from ' + money(row[P])));
    return a;
  }
  function renderSimilar() {
    similar.innerHTML = '';
    similar.hidden = false;
    similar.appendChild(el('h2', 'pcp-h2', 'Paintings with a similar palette'));
    var grid = el('div', 'pcp-grid');
    grid.setAttribute('data-pcp-similar-grid', '');
    grid.appendChild(el('p', 'pcp-empty', 'Matching the catalogue…'));
    similar.appendChild(grid);
    var hexes = state.pal.slice(0, 5).map(function (c) { return c.hex; });
    if (!hexes.length) return;
    ArtSeeCatalog.similarColor(hexes, { limit: 14 }).then(function (rows) {
      grid.innerHTML = '';
      var n = 0;
      rows.forEach(function (r) {
        if (state.row && r[H] === state.row[H]) return;
        if (n >= 12) return;
        n++; grid.appendChild(cardFor(r));
      });
      if (!n) grid.appendChild(el('p', 'pcp-empty', 'No close match in the catalogue.'));
      root.setAttribute('data-pcp-ready', '1');
    }, function () {
      grid.innerHTML = '';
      grid.appendChild(el('p', 'pcp-empty', 'The catalogue index did not answer.'));
    });
  }

  /* ------------------------------------------------------------- selection */
  function loadRow(row, isCompare) {
    var url = ArtSeeCatalog.imageUrl(row, 400);
    return readPalette(url, true).then(function (pal) {
      return { pal: pal, exact: true };
    }, function () {
      var fb = paletteFromRow(row);
      if (!fb.length) throw new Error('no palette');
      return { pal: fb, exact: false };
    }).then(function (res) {
      if (isCompare) { state.vsRow = row; state.vsPal = res.pal; }
      else { state.row = row; state.pal = res.pal; state.src = url; state.exact = res.exact; }
      hashWrite();
      renderPanel();
      track('tool_result', { handle: row[H], exact: res.exact });
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  function readPalette(url, cors) {
    return new Promise(function (res, rej) {
      var img = new Image();
      if (cors) img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var pal = extractFromImage(img, SWATCHES);
          if (!pal.length) return rej(new Error('empty'));
          res(pal);
        } catch (e) { rej(e); }
      };
      img.onerror = function () { rej(new Error('image')); };
      img.src = url;
    });
  }

  /* ---------------------------------------------------------- search + UI */
  var sTimer = null;
  function wireSearch() {
    qIn.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = qIn.value.trim();
      if (q.length < 2) { sugg.hidden = true; sugg.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        ArtSeeCatalog.search(q, { limit: 8 }).then(function (rows) {
          sugg.innerHTML = '';
          if (!rows.length) { sugg.hidden = true; return; }
          rows.forEach(function (r) {
            var b = el('button', 'pcp-sugg__item');
            b.type = 'button';
            b.appendChild(el('strong', null, r[T]));
            b.appendChild(el('span', null, r[A]));
            b.addEventListener('click', function () {
              sugg.hidden = true; qIn.value = '';
              qIn.placeholder = qIn.getAttribute('data-ph') || qIn.placeholder;
              var cm = state.compareMode; state.compareMode = false;
              loadRow(r, cm && !!state.row);
            });
            sugg.appendChild(b);
          });
          sugg.hidden = false;
        }, function () { sugg.hidden = true; });
      }, 180);
    });
    document.addEventListener('click', function (e) {
      if (!sugg.contains(e.target) && e.target !== qIn) sugg.hidden = true;
      if (!e.target.closest || !e.target.closest('.pcp-menu')) document.querySelectorAll('.pcp-menu__list').forEach(function (n) { n.hidden = true; });
    });
  }

  var STARTERS = [
    ['vincent-van-gogh-paintings-the-starry-night', 'starry night'],
    ['claude-monet-paintings-water-lilies', 'water lilies'],
    ['johannes-vermeer-paintings-the-girl-with-a-pearl-earring', 'girl with a pearl earring'],
    ['gustav-klimt-paintings-the-kiss', 'the kiss'],
    ['leonardo-da-vinci-paintings-mona-lisa', 'mona lisa'],
    ['edvard-munch-paintings-the-scream', 'the scream'],
    ['alexandre-cabanel-paintings-birth-of-venus', 'birth of venus'],
    ['vincent-van-gogh-paintings-sunflowers', 'sunflowers'],
    ['vincent-van-gogh-paintings-cafe-terrace-at-night-place-du-forum-arles', 'cafe terrace at night'],
    ['caspar-david-friedrich-paintings-the-wanderer-above-the-sea-of-fog', 'wanderer above the sea of fog'],
    ['claude-monet-paintings-meadows-in-giverny', 'giverny'],
    ['vincent-van-gogh-paintings-starry-night-over-the-rhone', 'starry night over the rhone']
  ];
  function renderStarters(rows) {
    var byHandle = {};
    for (var i = 0; i < rows.length; i++) byHandle[rows[i][H]] = rows[i];
    starter.innerHTML = '';
    var picked = {}, pending = [];
    STARTERS.forEach(function (s) {
      var r = byHandle[s[0]];
      if (r && !picked[r[H]]) { picked[r[H]] = 1; starter.appendChild(tile(r)); }
      else pending.push(s[1]);
    });
    // a handle that has moved is recovered by name, so the grid never renders short
    pending.forEach(function (q) {
      ArtSeeCatalog.search(q, { limit: 3 }).then(function (hits) {
        for (var i = 0; i < hits.length; i++) {
          if (!picked[hits[i][H]]) { picked[hits[i][H]] = 1; starter.appendChild(tile(hits[i])); return; }
        }
      }, function () { });
    });
    function tile(r) {
      var b = el('button', 'pcp-tile');
      b.type = 'button';
      var im = el('span', 'pcp-tile__img');
      var img = new Image();
      img.loading = 'lazy'; img.decoding = 'async';
      img.alt = r[T] + ' by ' + r[A];
      img.src = ArtSeeCatalog.imageUrl(r, 300);
      im.appendChild(img); b.appendChild(im);
      b.appendChild(el('span', 'pcp-tile__t', r[T]));
      b.appendChild(el('span', 'pcp-tile__a', r[A]));
      b.addEventListener('click', function () { var cm = state.compareMode; state.compareMode = false; loadRow(r, cm && !!state.row); });
      return b;
    }
  }

  /* ------------------------------------------------------- your own images */
  function wireUploads() {
    if (fileArt) fileArt.addEventListener('change', function () {
      var f = fileArt.files && fileArt.files[0];
      if (!f) return;
      var url = URL.createObjectURL(f);
      readPalette(url, false).then(function (pal) {
        state.row = null; state.vsRow = null; state.pal = pal; state.src = url; state.exact = true;
        hashWrite(); renderPanel();
        track('tool_result', { handle: 'upload', exact: true });
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, function () { alert('That file could not be read as an image.'); });
    });

    if (fileRoom) fileRoom.addEventListener('change', function () {
      var f = fileRoom.files && fileRoom.files[0];
      if (!f) return;
      var url = URL.createObjectURL(f);
      roomOut.hidden = false;
      roomOut.innerHTML = '';
      roomOut.appendChild(el('p', 'pcp-empty', 'Reading your room…'));
      readPalette(url, false).then(function (pal) { matchRoom(pal, url); },
        function () { roomOut.innerHTML = ''; roomOut.appendChild(el('p', 'pcp-empty', 'That file could not be read as an image.')); });
    });
  }

  function matchRoom(pal, url) {
    var chrom = [], neut = [];
    pal.forEach(function (c) {
      var rgb = hexToRgb(c.hex), hsl = rgb2hsl(rgb[0], rgb[1], rgb[2]);
      c.h = hsl[0]; c.s = hsl[1]; c.l = hsl[2];
      (c.s >= .12 && c.l > .08 && c.l < .92 ? chrom : neut).push(c);
    });
    var anchor = chrom[0] || pal[0];
    var comp = hsl2rgb(anchor.h + 180, Math.min(anchor.s || .3, .55), Math.min(.65, Math.max(.30, 1 - anchor.l)));
    var query = [anchor.hex];
    if (chrom[1]) query.push(chrom[1].hex);
    query.push(toHex(comp[0], comp[1], comp[2]));
    if (neut[0]) query.push(neut[0].hex);
    var roomL = pal.reduce(function (s, c) { return s + c.l * c.pct; }, 0) / (pal.reduce(function (s, c) { return s + c.pct; }, 0) || 1);

    roomOut.innerHTML = '';
    var head = el('div', 'pcp-room__head');
    var fig = el('div', 'pcp-room__fig');
    var im = new Image(); im.alt = 'Your room'; im.src = url; fig.appendChild(im);
    head.appendChild(fig);
    var side = el('div');
    side.appendChild(el('h3', null, 'Your room’s palette'));
    side.appendChild(proportionBar(pal));
    var sw = el('div', 'pcp-swatches pcp-swatches--compact');
    swatchList(pal, sw, true);
    side.appendChild(sw);
    side.appendChild(el('p', 'pcp-room__rule',
      'Rule: we match on your room’s main colour (' + nameOf(anchor.hex) + ') plus one deliberate opposite (#' +
      toHex(comp[0], comp[1], comp[2]).toUpperCase() + '), then keep only paintings whose overall brightness sits near the room’s. ' +
      'Analogous alone makes art disappear into the wall; the opposite is what makes it read as a choice.'));
    head.appendChild(side);
    roomOut.appendChild(head);

    var grid = el('div', 'pcp-grid');
    grid.appendChild(el('p', 'pcp-empty', 'Matching the catalogue…'));
    roomOut.appendChild(grid);

    ArtSeeCatalog.similarColor(query, { limit: 36 }).then(function (rows) {
      var scored = rows.map(function (r, i) {
        var p = paletteFromRow(r), tot = 0, lum = 0;
        p.forEach(function (c) { var rgb = hexToRgb(c.hex); lum += rgb2hsl(rgb[0], rgb[1], rgb[2])[2] * c.pct; tot += c.pct; });
        return { r: r, s: i / rows.length * 0.6 + Math.abs((tot ? lum / tot : .5) - roomL) * 0.8 };
      }).sort(function (a, b) { return a.s - b.s; }).slice(0, 12);
      grid.innerHTML = '';
      scored.forEach(function (o) { grid.appendChild(cardFor(o.r)); });
      if (!scored.length) grid.appendChild(el('p', 'pcp-empty', 'No close match in the catalogue.'));
      track('tool_result', { handle: 'room-match' });
    }, function () {
      grid.innerHTML = '';
      grid.appendChild(el('p', 'pcp-empty', 'The catalogue index did not answer.'));
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(tries) {
    tries = tries || 0;
    if (!window.ArtSeeCatalog) {
      if (tries > 60) { starter.innerHTML = ''; starter.appendChild(el('p', 'pcp-empty', 'The catalogue index did not load. Refresh the page and the tool will run.')); return; }
      return setTimeout(function () { boot(tries + 1); }, 150);
    }
    track('tool_open', {});
    wireSearch();
    wireUploads();
    ArtSeeCatalog.load('all').then(function (rows) {
      renderStarters(rows);
      var h = hashRead();
      if (!h.p) return;
      var byHandle = {};
      for (var i = 0; i < rows.length; i++) byHandle[rows[i][H]] = rows[i];
      var r = byHandle[h.p];
      if (!r) return;
      var chain = loadRow(r, false);
      if (h.vs && byHandle[h.vs]) chain.then(function () { return loadRow(byHandle[h.vs], true); });
    }, function () {
      starter.innerHTML = '';
      starter.appendChild(el('p', 'pcp-empty', 'The catalogue index did not load. Refresh the page and the tool will run.'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
